<template>
    <div>
        <template>
            <div style="font-size:16px; background-color: #005B5B;">
                <h5 class="text-white text-center"> {{ $t('globalTrans.'+title) }}
                </h5>
            </div>
        </template>
        <b-row class="mt-4">
            <!-- Area Type -->
            <b-col  lg="6" sm="12">
                <ValidationProvider name="Area Type" vid="area_type_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="area_type_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.area_type')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.area_type_id"
                            :options="areaTypeList"
                            id="area_type_id"
                            @change="getAreaTypeData(address.area_type_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Division -->
            <b-col lg="6" sm="12" >
                <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="division_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.division_id"
                            :options="divisionList"
                            id="division_id"
                            @change="changeDivisionId(address.division_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- District -->
            <b-col lg="6" sm="12">
                <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="district_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.district_id"
                            :options="districtList"
                            id="district_id"
                            @change="changeDistrictId(address.district_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- City Corporation -->
            <b-col lg="6" sm="12" v-show="cityCorporationShow">
                <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="city_corporation_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.city_corporation')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.city_corporation_id"
                            :options="cityCorporationList"
                            @change="changeWardId('city_corporation',address.city_corporation_id)"
                            id="city_corporation_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Upazila -->
            <b-col lg="6" sm="12" v-show="upazilaShow">
                <ValidationProvider name="Upazila" vid="upazilla_id" :rules="`${upazilaShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="upazilla_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.upazila')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.upazilla_id"
                            :options="upazilaList"
                            id="upazilla_id"
                            @change="changeUpazillaId(address.upazilla_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Pourashava -->
            <b-col lg="6" sm="12" v-show="pourashavaShow">
                <ValidationProvider name="Pourashava" vid="pauroshoba_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="pauroshoba_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.pourashava')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.pauroshoba_id"
                            :options="pauroshobaList"
                            @change="changeWardId('pauroshoba',address.pauroshoba_id)"
                            id="pauroshoba_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Union -->
            <b-col lg="6" sm="12" v-show="unionShow">
                <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="union_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.union')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.union_id"
                            :options="unionList"
                            @change="changeWardId('union',address.union_id)"
                            id="union_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Ward -->
            <b-col lg="6" sm="12" v-show="wardShow">
                <ValidationProvider name="Ward" vid="ward_id" :rules="`${wardShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="ward_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('org_pro.ward') }} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.ward_id"
                            :options="wardList"
                            @change="dataReturn"
                            id="ward_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xl="6" lg="6" sm="12">
                <ValidationProvider name="Address (En)" vid="address_en" rules="required">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="address_en"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('grant_config.address_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                            class="form-control"
                            v-model="address.address"
                            @change="dataReturn"
                            id="email"
                            :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xl="6" lg="6" sm="12">
                <ValidationProvider name="Address (Bn)" vid="address_bn" rules="required">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="address_bn"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('grant_config.address_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                            class="form-control"
                            v-model="address.address_bn"
                            @change="dataReturn"
                            id="email"
                            :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import Custom from '../../store/custom'

export default {
    props: ['title', 'data'],
    components: {
        ValidationProvider
    },
    data () {
        return {
            cityCorporationShow: false,
            upazilaShow: false,
            pourashavaShow: false,
            unionShow: false,
            wardShow: false,
            address: {
                division_id: 0,
                district_id: 0,
                area_type_id: 0,
                city_corporation_id: 0,
                upazilla_id: 0,
                pauroshoba_id: 0,
                union_id: 0,
                ward_id: 0,
                address: '',
                address_bn: ''
            },
            districtList: [],
            cityCorporationList: [],
            upazilaList: [],
            pauroshobaList: [],
            unionList: [],
            wardList: [],
            id: ''
        }
    },
    mounted () {
        if (this.data.area_type_id) {
            this.getAreaTypeData(parseInt(this.data.area_type_id))
            this.districtList = this.getDistrictList(parseInt(this.data.division_id))
            this.cityCorporationList = this.getCityCorporationList(parseInt(this.data.district_id))
            this.upazilaList = this.getUpazilaList(parseInt(this.data.district_id))
            this.pauroshobaList = this.getPauroshobaList(parseInt(this.data.upazilla_id))
            this.unionList = this.getUnionList(parseInt(this.data.upazilla_id))
            const areaType = parseInt(this.data.area_type_id)
            let type, id
            if (areaType === 1) {
                type = 'city_corporation'
                id = this.data.city_corporation_id
            } else if (areaType === 2) {
                type = 'pauroshoba'
                id = this.data.pauroshoba_id
            } else {
                type = 'union'
                id = this.data.union_id
            }
            this.changeWardId(type, id)
            this.address = this.data
            this.dataReturn()
        }
    },
    computed: {
        areaTypeList () {
            const objectData = Custom.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        divisionList () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        }
    },
    methods: {
        dataReturn () {
            this.$emit('address-data', this.address)
        },
        getAreaTypeData (typeId) {
            /**
             * 1 - City Corporation (City-Coporation, Ward)
             * 2 - Pauroshoba (Upazila, Pourosoba, Ward)
             * 3 - Union (Upazila, Pourosoba, Ward)
             */
            if (typeId === 1) {
                /** City Corporation */
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = true
                this.upazilaShow = false
                this.pourashavaShow = false
                this.unionShow = false
                this.wardShow = true
            } else if (typeId === 2) {
                /** Pauroshoba */
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = false
                this.upazilaShow = true
                this.pourashavaShow = true
                this.unionShow = false
                this.wardShow = true
            } else if (typeId === 3) {
                /** Union */
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = false
                this.upazilaShow = true
                this.pourashavaShow = false
                this.unionShow = true
                this.wardShow = true
            } else {
                // Resetting The Form & Data
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = false
                this.upazilaShow = false
                this.pourashavaShow = false
                this.unionShow = false
                this.wardShow = false
            }
            /** Updating cityCorporationList & upazilaList */
            this.cityCorporationList = this.getCityCorporationList(this.address.district_id)
            this.upazilaList = this.getUpazilaList(this.address.district_id)
            this.dataReturn()
        },
        getDistrictList (divisionId = null) {
            return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
        },
        getCityCorporationList (districtId = null) {
            return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
        },
        getUpazilaList (districtId = null) {
            return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
        },
        getUnionList (upazillaId = null) {
            return this.$store.state.commonObj.unionList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
        },
        getPauroshobaList (upazillaId = null) {
            return this.$store.state.commonObj.pauroshobaList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
        },
        changeWardId (areaType, id) {
            this.address.ward_id = 0
            const objectData = this.$store.state.commonObj.wardList
            objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
            if (areaType === 'city_corporation') this.wardList = objectData.filter(item => item.city_corporation_id === id)
            else if (areaType === 'pauroshoba') this.wardList = objectData.filter(item => item.pauroshoba_id === id)
            else this.wardList = objectData.filter(item => item.union_id === id)
            this.dataReturn()
        },
        changeDivisionId (divisionId) {
            this.address.district_id = 0
            this.districtList = this.getDistrictList(divisionId)
            this.dataReturn()
        },
        changeDistrictId (districtId) {
            this.address.city_corporation_id = 0
            this.address.upazilla_id = 0
            this.cityCorporationList = this.getCityCorporationList(districtId)
            this.upazilaList = this.getUpazilaList(districtId)
            this.dataReturn()
        },
        changeUpazillaId (upazillaId) {
            this.address.pauroshoba_id = 0
            this.address.union_id = 0
            this.pauroshobaList = this.getPauroshobaList(upazillaId)
            this.unionList = this.getUnionList(upazillaId)
            this.dataReturn()
        }
    }
}
</script>
